import { Navigate, useLocation } from "react-router-dom";
import { locationStateWithPrevious } from "../lib/query/location";
import { useBusinessesQuery } from "../generated/graphql";
import { useHypertune } from "../generated/hypertune.react";
import {
  extraAccountPath,
  sharedAccountPath,
  skipBlockAccountSessionStorageKey,
} from "../lib/constants";

export default function BlockAccount({
  children,
}: {
  children: React.ReactElement;
}): React.ReactElement {
  const { data } = useBusinessesQuery();

  const hypertune = useHypertune();

  const location = useLocation();

  const skipBlock = sessionStorage.getItem(skipBlockAccountSessionStorageKey);

  const blockSharedAccounts = hypertune
    .features()
    .blockSharedAccounts({ fallback: "noBlock" });

  const blockExtraAccounts = hypertune
    .features()
    .blockExtraAccounts({ fallback: "noBlock" });

  if (
    data?.me.isSharedAccount &&
    (blockSharedAccounts === "hardBlock" ||
      (blockSharedAccounts === "softBlock" && !skipBlock))
  ) {
    console.log(
      `[BlockAccount] blocking shared account; redirecting from:`,
      location
    );
    return (
      <Navigate
        to={sharedAccountPath}
        state={locationStateWithPrevious(location)}
        replace
      />
    );
  }

  if (
    data?.primaryBusiness?.isExtraAccount &&
    (blockExtraAccounts === "hardBlock" ||
      (blockExtraAccounts === "softBlock" && !skipBlock))
  ) {
    console.log(
      `[BlockAccount] blocking extra account; redirecting from:`,
      location
    );
    return (
      <Navigate
        to={extraAccountPath}
        state={locationStateWithPrevious(location)}
        replace
      />
    );
  }

  return children;
}
